const { map, groupBy, values, findIndex } = require('lodash');
const { falcorPortfolioId } = require('../../utils');
const base64 = require('base-64');

function parseUserNotifications(notification) {
  if (notification == null) return null;

  const oReturn = {
    total: parseInt(notification.alertNotificationCount),
    notifications: [],
  };

  map(notification.notificationDetails, (notificationDetail) => {
    oReturn.notifications.push({
      type: notificationDetail.type,
      count: notificationDetail.notificationCountNew,
      details: parseGroupByPortfolio(notificationDetail.notificationNew),
      detailsch: parseCategoryData(notificationDetail.notificationNew),
    });
  });

  return oReturn;
}

function parseGroupByPortfolio(reportsDetails) {
  const grouping = groupBy(reportsDetails, 'pfId');
  const groupCount = map(grouping, (value, key) => {
    return {
      portfolioId: falcorPortfolioId(key),
      portfolioTitle: key,
      count: value.length,
      params: value[0].params
    }
  });
  return groupCount;
}

function parseCategoryData(reportsDetails) {
  // const grouping = groupBy(reportsDetails, 'pfId');
  let categoryData = [];
  reportsDetails.map((item) => {
    const param = item.params;
    if(!param){
      return;
    }
    const categoryItem = {
      count: param.count,
      catId: param.catId,
      catName:param.catName,
    }
    categoryData.push(categoryItem);

  });

  return categoryData;
}

function parseReadUserNotifications(res) {
  const oReturn = {
    readSuccess: res.retCode == '1'
  };

  return JSON.stringify(oReturn);
}

function parseGetUserPrefNotifications(pref) {
  return {
    alertType: pref.alertType,
    value: pref.alertFlag,
  };
}

function parseSaveUserPrefNotifications(res) {
  const oReturn = {
    saveSuccess: res.retCode == '1'
  };

  return JSON.stringify(oReturn);
}

function serviceFactory({ notificationApi }) {
  const getUserNotifications = ({ roleId, lastLoginValue, metaData }) => {
    const notifications = notificationApi.getUserNotifications(roleId, lastLoginValue, metaData)
      .then(parseUserNotifications)
      .catch(() => null);

    const settings = notificationApi.getUserPrefNotifications(metaData)
      .then((response) => {
        const isVisible = findIndex(response, { alertFlag: 'T' }) >= 0;
        const MultiSignNotification = response.find((res) => res.alertType === 'multisigpayments' && res.alertFlag==='T')
        const isMultiSig = !!MultiSignNotification
        return{ isVisible, isMultiSig }
      })
      .catch(()=>({isVisible: null , isMultiSig: false}));

    return Promise.all([notifications, settings]).then(data => {
      if (!data) return null;
      const prefData = data[1];
      const result = Object.assign({}, data[0], { isVisible: prefData.isVisible },{isMultiSig: prefData.isMultiSig});
      return JSON.stringify(result);
    })
  }

  const getUserNotificationsCombine = ( roleId, lastLoginValue, langCode, metaData ) => {

    const notifications = notificationApi.getUserNotificationsCombine(roleId, lastLoginValue, langCode, metaData)
      .then(parseUserNotifications)
      .catch(() => null);
    const settings = notificationApi.getUserPrefNotifications(metaData)
      .then((response) => {
        return findIndex(response, { alertFlag: 'T' }) >= 0;
      })
      .catch(() => null);

    return Promise.all([notifications, settings]).then(data => {
      if (!data) return null;
      const result = Object.assign({}, data[0], { isVisible: data[1] });
      return result;
    })
  }


  const setAsReadUserNotifications = ({ metaData }) =>
    notificationApi.setAsReadUserNotifications(metaData)
      .then(parseReadUserNotifications)
      .catch(() => null);

  const getUserPrefNotifications = ({ metaData }) =>
    notificationApi.getUserPrefNotifications(metaData)
      .then((response) => {
        const oReturn = map(response, parseGetUserPrefNotifications);
        return JSON.stringify(oReturn);
      })
      .catch(() => null);

  const saveUserPrefNotifications = ({ alertTypes, metaData }) => {
    if (typeof alertTypes === 'string' && alertTypes !== '') {
      // const parsedAlertTypes = JSON.parse(base64.decode(alertTypes));
      // const arrayAlertTypes = values(parsedAlertTypes);
      return notificationApi.saveUserPrefNotifications(alertTypes, metaData)
        .then(parseSaveUserPrefNotifications)
        .catch(() => null);
    }
  }

  return {
    getUserNotifications,
    setAsReadUserNotifications,
    getUserPrefNotifications,
    saveUserPrefNotifications,
    getUserNotificationsCombine
  };
}

module.exports = serviceFactory;
